import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { updateCompany2, companyUpdated } from 'actions/company';

import { Link } from 'react-router';
import NotFound from 'components/NotFound';
import NavBarConfig from 'components/NavBarConfig';
import CompanyUpdate from 'components/company/CompanyUpdate';
import { FORM_ERROR } from 'final-form';
import nfetch from 'actions/nfetch';
import BillingCurrentMonth from 'pages/company/components/BillingCurrentMonth';
import BillingDownloadList from 'pages/company/components/BillingDownloadList';

const messages = defineMessages({
  BACK: { id: 'CompanyUpdatePage.BACK', defaultMessage: 'Zurück' },
  EDIT_COMPANY: { id: 'CompanyUpdatePage.EDIT_COMPANY', defaultMessage: 'Unternehmensprofil' },
  TAB_GENERAL: { id: 'CompanyUpdatePage.TAB_GENERAL', defaultMessage: 'Allgemein' },
  TAB_TEXTS: { id: 'CompanyUpdatePage.TAB_TEXTS', defaultMessage: 'Texte & Links' },
  TAB_TARIFF: { id: 'CompanyUpdatePage.TAB_TARIFF', defaultMessage: 'Mein Tarif' },
  TAB_EVN: { id: 'CompanyUpdatePage.TAB_EVN', defaultMessage: 'Einzelverbindungsnachweise' },
  COMPANY_SETTINGS: { id: 'CompanyUpdatePage.COMPANY_SETTINGS', defaultMessage: 'Unternehmenseinstellungen' },
  COMPANY_SETTINGS_DESC: { id: 'CompanyUpdatePage.COMPANY_SETTINGS_DESC', defaultMessage: 'Verwalten Sie hier die grundlegenden Einstellungen, Limits und Datenschutzvorgaben des Unternehmens.' },
});

class CompanyUpdatePage extends Component {
  constructor(props) {
    super(props);
    
    let initialTab = 'general';
    if (props.location && props.location.query && props.location.query.tab) {
      initialTab = props.location.query.tab;
    }
    
    this.state = {
      activeTab: initialTab,
      filter: ''
    };
  }

  handleSearchChange = (e) => {
    this.setState({ filter: e.target.value });
  }

  renderTabNav(tabId, label, icon) {
    const isActive = this.state.activeTab === tabId;
    return (
      <button
        onClick={() => this.setState({ activeTab: tabId })}
        style={{
          padding: '16px 24px', backgroundColor: 'transparent', border: 'none',
          borderBottom: isActive ? '3px solid var(--card-text-active)' : '3px solid transparent',
          color: isActive ? 'var(--card-text-active)' : 'var(--text-muted)', fontWeight: isActive ? 'bold' : 'normal',
          fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', outline: 'none'
        }}
      >
        <i className={`fa ${icon}`} /> {label}
      </button>
    );
  }

  render() {
    const { user, company, companyMembership, onSubmit, routes, intl: { formatMessage }, billing } = this.props;
    const { activeTab, filter } = this.state;
    const isGlobalAdmin = user && user.is_admin;
    const isCompanyAdmin = companyMembership && (companyMembership.is_owner || companyMembership.is_admin);

    if (!company || !companyMembership) { return null; }
    if (!isGlobalAdmin && !isCompanyAdmin) {
      return <NotFound />;
    }

    return (
      <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%' }}>
        <NavBarConfig updatePage currentRouteName={routes[routes.length - 1].name} />
        
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                <i className="fa fa-cog" />
              </div>
              <div>
                {formatMessage(messages.EDIT_COMPANY)}
                <span style={{ display: 'block', fontSize: '14px', fontWeight: 'normal', color: 'var(--text-muted)', marginTop: '4px' }}>
                  {company.name}
                </span>
              </div>
            </h2>
          </div>

          {/* Main Card */}
          <div style={{ maxWidth: '800px', backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
            {/* Tab Content */}
            <div style={{ padding: '32px' }}>
              {activeTab === 'general' && (
                <div style={{ maxWidth: '600px' }}>
                  <h3 style={{ marginTop: 0, color: 'var(--text-color)', fontSize: '18px', fontWeight: 'bold' }}>{formatMessage(messages.COMPANY_SETTINGS)}</h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginBottom: '24px' }}>{formatMessage(messages.COMPANY_SETTINGS_DESC)}</p>
                  <CompanyUpdate onSubmit={onSubmit} initialValues={company} isAdmin={isGlobalAdmin} mode="general" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ConnectedCompanyUpdatePage = connect(
  state => ({
    user: state.auth.user
  }),
  (dispatch, props) => ({
    onSubmit: async formData => {
      const data = await updateCompany2(props.params.companyId, formData);
      if (data.response) {
        const company = data.response;
        dispatch(companyUpdated(company));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    }
  })
)(injectIntl(CompanyUpdatePage));

const CompanyUpdatePageNfetch = nfetch(
  ({ params }) => ({ billing: { url: `/api/company/${params.companyId}/billing` } }),
)(ConnectedCompanyUpdatePage);

export default CompanyUpdatePageNfetch;
